import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "topic-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopicListItem = _resolveComponent("TopicListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRecipes(_ctx.recommendRecipes), (recipe) => {
      return (_openBlock(), _createBlock(_component_TopicListItem, {
        class: "topic-list-item",
        key: recipe.recipeId,
        recipeImageUrl: recipe.images[0].thumb,
        recipeLabel: recipe.title,
        onOnClick: ($event: any) => (_ctx.selectRecipe(recipe.recipeId, recipe.type))
      }, null, 8, ["recipeImageUrl", "recipeLabel", "onOnClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}